export default __webpack_public_path__ + "static/serviveNow1-1e5795db627a6225f48db29b85b4eaaf.svg";